import { Check, CircleAlert, Loader2, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useHealth } from "@/lib/api/stats.queries";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/Button";

export function Header() {
  const auth = useAuth();
  const healthProbe = useHealth();

  const healthLabel = healthProbe.isPending
    ? "…"
    : healthProbe.isSuccess
      ? "API activa"
      : "API caída";
  const healthTone = healthProbe.isPending
    ? "bg-slate-100 text-slate-600"
    : healthProbe.isSuccess
      ? "bg-emerald-100 text-emerald-700"
      : "bg-red-100 text-red-700";

  let authPill: { tone: string; icon: React.ReactNode; label: string };
  if (auth.status === "loading") {
    authPill = {
      tone: "bg-slate-100 text-slate-600",
      icon: <Loader2 className="h-3.5 w-3.5 animate-spin" />,
      label: "Verificando",
    };
  } else if (auth.status === "authenticated") {
    authPill = {
      tone: "bg-emerald-100 text-emerald-700",
      icon: <ShieldCheck className="h-3.5 w-3.5" />,
      label: "Admin",
    };
  } else {
    authPill = {
      tone: "bg-red-100 text-red-700",
      icon: <CircleAlert className="h-3.5 w-3.5" />,
      label: "Sin sesión",
    };
  }

  const phone =
    auth.status === "authenticated" || auth.status === "forbidden"
      ? auth.user.phone
      : null;

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white">
      <div className="flex items-center gap-3 px-4 h-14">
        <div className="flex items-center gap-2 min-w-0">
          <div className="h-7 w-7 rounded-md bg-brand-600 flex items-center justify-center">
            <Check className="h-4 w-4 text-white" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900 leading-tight truncate">
              PahFacturar
            </p>
            <p className="text-[11px] text-slate-500 leading-tight">Admin</p>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2">
          {phone && (
            <span className="text-xs text-slate-500 font-mono hidden sm:inline">
              {phone}
            </span>
          )}
          <span
            className={cn(
              "inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-medium",
              authPill.tone,
            )}
          >
            {authPill.icon}
            {authPill.label}
          </span>
          <span
            className={cn(
              "inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-medium",
              healthTone,
            )}
          >
            {healthLabel}
          </span>
          {auth.status === "authenticated" && (
            <Button type="button" variant="ghost" size="sm" onClick={() => auth.signOut()}>
              <LogOut className="h-3.5 w-3.5" />
              Salir
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}